/* T8 Product rail: on product pages, swap the server-filled "same collections" pieces for Shopify's related recommendations
   (/recommendations/products?intent=related) when they return at least data-min pieces; otherwise keep what is there */
(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-t8-prail-reco]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var track = sec.querySelector('[data-t8-rail-track]'); if (!track) return;
      fetch(sec.dataset.t8PrailReco).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-t8-rail-track]');
        var items = fresh ? fresh.querySelectorAll('.t8-prail__item [data-t8-pcard]') : [];
        if (items.length < (Number(sec.dataset.min) || 4)) return;
        track.innerHTML = fresh.innerHTML;
        track.scrollLeft = 0;
        track.dispatchEvent(new Event('scroll'));
        document.dispatchEvent(new CustomEvent('t8:cards:added', { detail: { root: track } }));
      }).catch(function () {});
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
